import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Navbar, Nav, Container, NavDropdown, Form, Button, Row, Col, Badge } from 'react-bootstrap';
import { logout } from '../../redux/slices/authSlice';
import { setPeriod, clearPeriod } from '../../redux/slices/periodSlice';

const NavigationBar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, isAuthenticated } = useSelector((state) => state.auth);
  const { startDate, endDate } = useSelector((state) => state.period);

  const [draftStart, setDraftStart] = useState('');
  const [draftEnd, setDraftEnd] = useState('');

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  const handleApplyPeriod = () => {
    dispatch(setPeriod({ startDate: draftStart, endDate: draftEnd }));
  };

  const handleClearPeriod = () => {
    setDraftStart('');
    setDraftEnd('');
    dispatch(clearPeriod());
  };

  const hasPeriod = startDate || endDate;

  if (!isAuthenticated) {
    return null;
  }

  return (
    <>
      <Navbar bg="dark" variant="dark" expand="lg">
        <Container>
          <Navbar.Brand as={Link} to="/dashboard">
            Gestión de Cuotas
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link as={Link} to="/dashboard">Dashboard</Nav.Link>
              <Nav.Link as={Link} to="/payments">Visacuotas</Nav.Link>
              <Nav.Link as={Link} to="/incomes">Ingresos</Nav.Link>
              <Nav.Link as={Link} to="/expenses">Egresos</Nav.Link>
              <Nav.Link as={Link} to="/categories">Categorías</Nav.Link>
              <Nav.Link as={Link} to="/fixed-expenses">Gastos Fijos</Nav.Link>
              {user?.role === 'admin' && (
                <Nav.Link as={Link} to="/admin">Administración</Nav.Link>
              )}
            </Nav>
            <Nav>
              <NavDropdown title={user?.username} id="user-dropdown" align="end">
                <NavDropdown.Item disabled>
                  {user?.email}
                </NavDropdown.Item>
                <NavDropdown.Item disabled>
                  Rol: {user?.role}
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item onClick={handleLogout}>
                  Cerrar Sesión
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <div style={{ backgroundColor: '#2c2c2c', borderBottom: '1px solid #444', padding: '6px 0' }}>
        <Container>
          <Row className="align-items-center g-2">
            <Col xs="auto">
              <small style={{ color: '#adb5bd', fontWeight: 600, letterSpacing: '0.03em' }}>
                PERÍODO
              </small>
            </Col>
            <Col xs="auto">
              <Form.Control
                type="date"
                size="sm"
                value={draftStart}
                onChange={(e) => setDraftStart(e.target.value)}
                style={{ backgroundColor: '#3a3a3a', border: '1px solid #555', color: '#fff', width: 150 }}
              />
            </Col>
            <Col xs="auto">
              <small style={{ color: '#adb5bd' }}>→</small>
            </Col>
            <Col xs="auto">
              <Form.Control
                type="date"
                size="sm"
                value={draftEnd}
                onChange={(e) => setDraftEnd(e.target.value)}
                style={{ backgroundColor: '#3a3a3a', border: '1px solid #555', color: '#fff', width: 150 }}
              />
            </Col>
            <Col xs="auto">
              <Button size="sm" variant="outline-light" onClick={handleApplyPeriod}>
                Aplicar
              </Button>
            </Col>
            {hasPeriod && (
              <Col xs="auto">
                <Button size="sm" variant="outline-danger" onClick={handleClearPeriod}>
                  Limpiar
                </Button>
              </Col>
            )}
            {hasPeriod && (
              <Col xs="auto">
                <Badge bg="warning" text="dark" style={{ fontSize: '0.7rem' }}>
                  {startDate || '…'} → {endDate || '…'}
                </Badge>
              </Col>
            )}
          </Row>
        </Container>
      </div>
    </>
  );
};

export default NavigationBar;
